module.exports = __webpack_public_path__ + "img/fleet-insights-white-text_orange-logo.0c2bdb83.svg";